export enum ShadowOption {
	NO_SHADOW = '',
	WITH_SHADOW = '_withshadow',
}
